import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

import {
  schoolBreakFieldErrorsMapper,
  type SchoolBreakEditFormPayload
} from '../constants/school-break-payload'

const useEditSchoolBreak = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (payload: SchoolBreakEditFormPayload) =>
      httpService.panel.panelSchoolBreaksUpdate(payload.id, {
        name: payload.name,
        start_date: formatApiDate(payload.dates.from),
        end_date: formatApiDate(payload.dates.to)
      }),
    onSuccess,
    onError,
    fieldErrorsMapper: schoolBreakFieldErrorsMapper
  })

export default useEditSchoolBreak
